module.exports = __webpack_public_path__ + "img/leadercare-top.9c240010.png";